import { render, staticRenderFns } from "./AdminTripForm.vue?vue&type=template&id=babdb82a&scoped=true"
import script from "./AdminTripForm.vue?vue&type=script&lang=js"
export * from "./AdminTripForm.vue?vue&type=script&lang=js"
import style0 from "./AdminTripForm.vue?vue&type=style&index=0&id=babdb82a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babdb82a",
  null
  
)

export default component.exports